import { useMemo } from 'react';
import {
  mapFromCompanyToAnnualRevenueEarnings,
  mapToAnnualRevenueEarnings,
} from '../../components/TimeseriesPlot/mappers/timeseriesMap';
import { getJsonField } from '@/utilities/object';
import { isNumber } from 'lodash';
import { NarrativeCompany, NarrativeValuation } from '../useNarrativeById';

type FiscalData = NarrativeValuation['fiscalData'];

export const usePastAnnualRevenueEarnings = ({
  company,
  fiscalData,
}: {
  company: NarrativeCompany;
  fiscalData?: FiscalData;
}) => {
  const pastAnnualRevenueEarnings = useMemo(() => {
    if (!company || !company.analysisPast)
      return {
        mostRecentReportedDate: '',
        yearlyTimeSeries: {},
      };

    return fiscalData
      ? mapToAnnualRevenueEarnings(fiscalData)
      : mapFromCompanyToAnnualRevenueEarnings(
          company.analysisPast,
          getJsonField<number>(
            company.data.currencyInfo,
            'reporting_unit',
            isNumber
          ) ?? 1
        );
  }, [fiscalData, company]);

  return pastAnnualRevenueEarnings;
};
